export default __webpack_public_path__ + "static/media/express-white-text.cca64e0f.png";